/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// @packages
import MockAdapter from 'axios-mock-adapter';
import axios from 'axios';

// @scripts
import { config } from '../config';
import { createMockResponse, getMockParams } from '../../utils/mock';
import { format } from '../../utils/string';

// @enums
enum HttpCodes {
  success = 200,
  unauthorized = 401
}

type CustomObject = {
  [key: string]: any;
};

const mockedServices = {
  mockServiceSecurityLogin: (mockAdapter: MockAdapter) => {
    mockAdapter
      .onPost(config.services.security.login)
      .reply((call: unknown) => {
        const { email, password } = getMockParams(call);
        const { loginUserName, loginPassword } = config.settings.serviceMocker;
        const success = email === loginUserName && password === loginPassword;
        return createMockResponse({
          data: success ? config.mockData.security.user : null,
          httpCode: success ? HttpCodes.success : HttpCodes.unauthorized
        });
      });
  },
  mockServiceSites: (mockAdapter: MockAdapter) => {
    const url = config.services.locations.sites;
    const pathRegexp = new RegExp(format(url, '.*'));
    mockAdapter
      .onGet(pathRegexp)
      .reply(() => createMockResponse({
        data: config.mockData.sitesDetails,
        httpCode: HttpCodes.success
      }));
  },
  mockServiceSiteDetails: (mockAdapter: MockAdapter) => {
    const url = config.services.locations.siteDetails;
    const pathRegexp = new RegExp(format(url, '.*'));
    mockAdapter
      .onGet(pathRegexp)
      .reply((call: Record<string, any>) => {
        const siteId = call.url.split('/').pop();
        const currentSite = config.mockData.sitesDetails.find((e) => e.site_id === Number(siteId));
        return createMockResponse({
          data: currentSite || null,
          httpCode: currentSite ? HttpCodes.success : HttpCodes.unauthorized
        });
      });
  },
  mockServiceTestingSite: (mockAdapter: MockAdapter) => {
    const url = config.services.testing.siteTestSchedule;
    const pathRegexp = new RegExp(format(url, '.*'));
    mockAdapter
      .onGet(pathRegexp)
      .reply((call: Record<string, any>) => {
        const siteId = call.url.split('/').pop();
        const currentSite = config.mockData.siteTesting
          .find((e) => e.site_id === Number(siteId));
        return createMockResponse({
          data: currentSite?.data || null,
          httpCode: currentSite ? HttpCodes.success : HttpCodes.unauthorized
        });
      });
  },
  mockServiceTestSessions: (mockAdapter: MockAdapter) => {
    const url = config.services.testing.siteTestSchedule;
    mockAdapter
      .onGet(url)
      .reply(() => createMockResponse({
        data: config.mockData.siteTestSchedule,
        httpCode: HttpCodes.success
      }));
  },
  mockServiceSiteEnrollments: (mockAdapter: MockAdapter) => {
    const url = config.services.strategies.siteEnrollments;
    const pathRegexp = new RegExp(format(url, '.*'));
    mockAdapter
      .onGet(pathRegexp)
      .reply((call: Record<string, any>) => {
        const siteId = call.url.split('/').pop();
        const currentSite = config.mockData.siteEnrollments
          .find((e) => e.site_id === Number(siteId));
        return createMockResponse({
          data: currentSite?.data || null,
          httpCode: currentSite ? HttpCodes.success : HttpCodes.unauthorized
        });
      });
  }
} as CustomObject;

export const initializeServiceMocker = () => {
  const mockAdapter = new MockAdapter(axios, {
    delayResponse: config.settings.serviceMocker.delayResponse
  });
  const serviceMocker = {
    replyWithMockData: () => {
      const include = config.settings.serviceMocker.include || [];
      Object.keys(mockedServices).forEach((name) => {
        if (include.some((item) => item === name)) {
          mockedServices[name](mockAdapter);
        }
      });
      mockAdapter.onAny().passThrough();
    },
    replyWithNetworkError: () => {
      mockAdapter.reset();
      mockAdapter.onAny().networkError();
    }
  };

  serviceMocker.replyWithMockData();
  return serviceMocker;
};
